import React, { lazy } from "react";

import { VIEW_ACCOUNTS_PERMISSION } from "constants/permissions";

const FcmPushCenterAssignPage = lazy(() => import("./FcmPushCenterAssignPage"));

const fcmPushCenterAssignRoute = {
  path: "push_centers.fcm_center",
  element: <FcmPushCenterAssignPage />,
  root: false,
  permission: ["view_push_centers_fcm", VIEW_ACCOUNTS_PERMISSION],
};

export default fcmPushCenterAssignRoute;
